import { render, staticRenderFns } from "./Error.vue?vue&type=template&id=d71fba16"
var script = {}
import style0 from "./Error.vue?vue&type=style&index=0&id=d71fba16&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports